goog.provide('el8.ptdata.model.note.vitalsSet');

goog.require('el8.ptdata.model.note.editableSet');
goog.require('el8.model.base');
goog.require('el8.util.base');


// ---------------------
// * VISIT NOTE VITALS *
//
// The server wraps a VitalsCollection to provide this info for use by a VisitNote.
// Use el8.ptdata.vitalsCollections instead if working with Vitals as standalone Documents.
// ---------------------
el8.ptdata.model.note.vitalsSet = function(_noteId, _model, _data, _customName) {

    var _set = new el8.ptdata.model.note.editableSet({
        model: function(spec) {
            if (!spec.noteId) { spec.noteId = _noteId || null; }
            if (_customName) { spec.name = _customName; }
            return _model(spec);
        },
        sortFn: function(a, b) {
            // ascending recordDate order; tie break on ID
            var sortVal = a.getRecordDate() - b.getRecordDate();
            if (sortVal === 0) {
                return a.getId() - b.getId();
            }
            return sortVal;
        },
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            var that = this;

            var vitalUrlName = item.getName();
            if (item.isCustom()) { vitalUrlName = 'custom'; }
            var url = el8Globals['PATIENT_PATH']+'visit-notes/'+item.getIdForUrl()+'/' +
                    vitalUrlName+'/'+(item.getId() ? item.getId()+'/' : '');

            $.el8_ajax({
                type: 'POST',
                url: url,
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    // When we are amending a visit note, the server will send down a 
                    // replacement vital obj with a different ID. We will just do a strict
                    // replace and then wait for the full "save" to sync up the entire
                    // history-complete visit note version. For now we just stay sync'd with 
                    // the "latest" most relevant version.
                    if (item.getId()) {
                        that.updateItemId(item, data.id);
                    } else {
                        item.setId(data.id);
                    }
                    // pretty hacky way of getting a weightDelta back onto the parent note
                    // after a weight value has changed
                    if (data.weight_delta) {
                        var note = el8.ptdata.fetchById(item.getNoteId());
                        if (note && note.setWeightDelta) {
                            note.setWeightDelta(data.weight_delta);
                        }
                    }
                    item.populate(data);
                    that.sorted();
                    if (successCb) { successCb(); }
                    $(document).trigger('el8_noteVitalUpdate');
                },
                async: opts.async,
                // Over-ride regular error behavior because we are expecting
                // the visit note lastDitchSave() to rescue everything
                error_override: function() {
                    if (opts.errorCb) { opts.errorCb(); }
                }
            });
        },
        deleteFn: function(item, successCb, errorCb) {
            var that = this;
            $.el8_ajax({
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+item.getIdForUrl()+'/'+item.getName()+'/'+
                    (item.getId() ? item.getId()+'/' : ''),
                type: 'DELETE',
                success: function(data) {
                    that.remove(item);
                    if (successCb) { successCb(); }
                },
                // Over-ride regular error behavior because we are expecting
                // the visit note lastDitchSave() to rescue everything
                error_override: function() {
                    if (errorCb) { errorCb(); }
                }
            });
        }
    });

    _set.create(_data);
    return _set;
};


(function() {

    var vitalClass = function(spec) {
        spec = spec || {};
        this.populate(spec);
    };
    vitalClass.inheritsFrom(el8_Entity);
    vitalClass.makeRecorded();
    vitalClass.addStringProperty('name', true);
    vitalClass.addStringProperty('extraNote', true);
    vitalClass.addIntProperty('noteId');
    vitalClass.addIntProperty('replacedByEditId');
    vitalClass.addIntProperty('editId');
    vitalClass.addBoolean('custom');

    // gets sent up to enable delta calculations for weight/custom observations
    vitalClass.addStringProperty('previousValue', true);

    vitalClass.prototype.getIdForUrl = function() {
        return this.getNoteId() + (this.getEditId() ? '-'+this.getEditId() : '');
    };
    vitalClass.prototype.asMap = function() {
        return el8_Entity.prototype.asMap.call(this, true);
    };

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'bp';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('bpD', true);
        _class.addStringProperty('bpS', true);

        el8.ptdata.model.note.bp = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'rr';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('rr', true);

        el8.ptdata.model.note.rr = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'hr';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('hr', true);

        el8.ptdata.model.note.hr = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'height';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('height', true);
        _class.addStringProperty('units', true);
        _class.prototype.getDisplayHeight = function(inFeet) {
            if (!el8.util.isNone(this.getHeight())) {
                if (inFeet) {
                    var heightInInches = this.getHeight() * 1;
                    var feet = Math.floor( heightInInches / 12 );
                    var inches = heightInInches % 12;
                    return ( feet +  "'" + inches );
                } else {
                    return this.getHeight() + ' in.';
                }
            }
            return null;
        };

        el8.ptdata.model.note.height = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'weight';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('weight', true);
        _class.addStringProperty('units', true);
        _class.prototype.getDisplayWeight = function() {
            if (!el8.util.isNone(this.getWeight())) {
                return this.getWeight() + ' lbs.';
            }
            return null;
        };

        el8.ptdata.model.note.weight = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'pain';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('pain', true);

        el8.ptdata.model.note.pain = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'temperature';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('temperature', true);
        _class.addStringProperty('units', true);
        _class.prototype.getDisplayTemperature = function() {
            if (!el8.util.isNone(this.getTemperature())) {
                return this.getTemperature() + ' °F';
            }
            return null;
        };

        el8.ptdata.model.note.temperature = function(spec) { return new _class(spec); };
    })();

    (function() {
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'oxygen';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('percent', true);

        el8.ptdata.model.note.oxygen = function(spec) { return new _class(spec); };
    })();

    (function() {
        // Head Circumference
        var _class = function(spec) { 
            spec = spec || {};
            spec['name'] = 'hc';
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('hc', true);
        _class.prototype.getDisplayHc = function() {
            if (!el8.util.isNone(this.getHc())) {
                return this.getHc() + ' cm';
            }
            return null;
        };

        el8.ptdata.model.note.hc = function(spec) { return new _class(spec); };
    })();

    (function() {
        // Any practice-custom observation
        var _class = function(spec) { 
            spec = spec || {};
            spec['custom'] = true;
            this.parent.constructor.call(this, spec); 
        };
        _class.inheritsFrom(vitalClass);
        _class.addStringProperty('value', true);
        _class.addDateTime('previousTime', true);

        _class.addStringProperty('label');
        _class.addStringProperty('units');
        _class.addStringProperty('delta');

        _class.prototype.getDisplayValue = function() {
            var str = this.getValue();
            if (this.getUnits()) {
                str += ' '  + this.getUnits();
            }
            return str;
        };

        el8.ptdata.model.note.customObservation = function(spec) { return new _class(spec); };
    })();

})();


